import React from 'react';
import { useMemoryGameStore } from '../../../stores/index.js';
import { renderMarkdownToReact } from '@core/frontend/ui';

const GameHeader = () => {
    const { config } = useMemoryGameStore();
    const headline = config?.headline;
    const introText = config?.introText;

    return (
        <header className="text-center mb-3 px-2 w-100">
            <h1 className="h2 text-primary fw-bold mb-2">{headline || 'Memory-Spiel'}</h1>
            <p className="mx-auto mb-0">
                {renderMarkdownToReact(introText || 'Finde alle Paare und decke interessante Fakten auf!')}
            </p>
        </header>
    );
};

export default GameHeader;
